import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnyRecord } from 'dns';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ArrivalVM, DepartureVM, StationVM, TerminalVM, DepartureCreate, ArrivalCreate } from '../models/ArrivalDepartureModel';
import { AuthService } from '../services/auth.service';
import { filterTerminalsByDate } from '../models/BookingModel';

@Injectable({
  providedIn: 'root'
})
export class ArrivalDepartureService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  arrivalDeparturePath = 'Shuttlebuss/Shuttlebuss.Service/arrivaldeparture';

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  public getArrivalsStationBetweenArrivalDate(stationId: string, arrivalDateFrom: string, arrivalDateTo: string): Observable<ArrivalVM[]> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/arrivals/${stationId}/${arrivalDateFrom}/${arrivalDateTo}`;
    return this.http.get<ArrivalVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getDeparturesStationBetweenDepartureDate(stationId: string, departureDateFrom: string, departureDateTo: string): Observable<DepartureVM[]> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/departures/${stationId}/${departureDateFrom}/${departureDateTo}`;
    return this.http.get<DepartureVM[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getArrival(arrivalId: string): Observable<ArrivalVM> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/arrival/${arrivalId}`;
    return this.http.get<ArrivalVM>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getDeparture(departureId: string): Observable<DepartureVM> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/departure/${departureId}`;
    return this.http.get<DepartureVM>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public createDeparture(departure: DepartureCreate): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}${this.arrivalDeparturePath}/departure/`;
    return this.http
      .post<any>(url, departure, { headers })
      .pipe(map(result => {
        return result;
      }),
        catchError(this.handleError)
      );
  }

  public createArrival(arrival: ArrivalCreate): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}${this.arrivalDeparturePath}/arrival/`;
    return this.http
      .post<any>(url, arrival, { headers })
      .pipe(map(result => {
        return result;
      }),
        catchError(this.handleError)
      );
  }

  public getStations(organizationId): Observable<StationVM[]> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/stations/${organizationId}`;
    return this.http.get<StationVM[]>(URL).pipe(
      map(stationsVM => {
        return stationsVM;
      }),
      catchError(this.handleError)
    );
  }

  public getTerminals(stationId: string, date?: Date | string | null): Observable<TerminalVM[]> {
    const URL = `${this.hostPath}${this.arrivalDeparturePath}/terminals/${stationId}`;
    return this.http.get<TerminalVM[]>(URL).pipe(
      map(terminalsVM => {
        return filterTerminalsByDate(terminalsVM, date);
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`arrivalDepartureService.handleError ${errMsg}`);
    return throwError(error);
  }
}
